import { Link } from 'react-router-dom';
import { PaymentMethods, GuaranteeMedallions } from '../storefront/TrustSignals';

/* ── Brand socials (official single-fill glyphs, no icon dependency) ───────── */
const SOCIALS = [
  {
    name: 'Instagram',
    href: 'https://instagram.com/ab8beauty',
    d: 'M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.43.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.43.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.43-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.43-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zm0 3.18A6.66 6.66 0 1 0 18.66 12 6.66 6.66 0 0 0 12 5.34zm0 10.98A4.32 4.32 0 1 1 16.32 12 4.32 4.32 0 0 1 12 16.32zm6.92-11.24a1.56 1.56 0 1 1-1.56-1.56 1.56 1.56 0 0 1 1.56 1.56z',
  },
  {
    name: 'TikTok',
    href: 'https://tiktok.com/@ab8beauty',
    d: 'M12.53 2c1.31-.02 2.6-.01 3.9-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.03-12.07z',
  },
  {
    name: 'Pinterest',
    href: 'https://pinterest.com/ab8beauty',
    d: 'M12.02 0C5.4 0 .03 5.37.03 11.99c0 5.08 3.16 9.42 7.62 11.16-.11-.95-.2-2.4.04-3.44.22-.94 1.41-5.96 1.41-5.96s-.36-.72-.36-1.78c0-1.66.97-2.91 2.17-2.91 1.02 0 1.52.77 1.52 1.69 0 1.03-.65 2.57-.99 3.99-.29 1.19.6 2.17 1.78 2.17 2.13 0 3.77-2.25 3.77-5.49 0-2.86-2.06-4.87-5.01-4.87-3.41 0-5.41 2.56-5.41 5.2 0 1.03.39 2.14.89 2.74.1.12.11.22.08.35-.09.37-.29 1.2-.33 1.36-.05.22-.17.27-.4.16-1.5-.69-2.43-2.88-2.43-4.65 0-3.78 2.75-7.25 7.92-7.25 4.16 0 7.39 2.97 7.39 6.92 0 4.14-2.61 7.46-6.23 7.46-1.21 0-2.35-.63-2.76-1.38l-.75 2.85c-.27 1.04-1 2.35-1.5 3.15 1.12.35 2.31.53 3.55.53 6.61 0 11.99-5.37 11.99-11.99C24 5.37 18.63 0 12.02 0z',
  },
  {
    name: 'Facebook',
    href: 'https://facebook.com/ab8beauty',
    d: 'M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.09 10.13 24v-8.44H7.08v-3.49h3.05V9.43c0-3.01 1.79-4.67 4.53-4.67 1.31 0 2.69.24 2.69.24v2.96h-1.52c-1.49 0-1.96.93-1.96 1.88v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.09 24 18.1 24 12.07z',
  },
];

/* ── Footer link columns ──────────────────────────────────────────────────── */
const COLUMNS = [
  {
    title: 'Shop',
    links: [
      { label: 'All Products', to: '/shop' },
      { label: 'Bubblé Balm Stick', to: '/shop/bubble' },
      { label: 'Blue Crème', to: '/shop/blue-creme' },
      { label: 'VERDÉ Scalp Therapy', to: '/shop/verde' },
    ],
  },
  {
    title: 'Rewards',
    links: [
      { label: 'Become an Ambassador', to: '/ambassadors' },
      { label: 'Join — Earn 3 / 2 / 1%', to: '/register' },
      { label: 'Affiliate Dashboard', to: '/affiliate' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About AB8', to: '/about' },
      { label: 'Press', to: '/press' },
      { label: 'Customer Support', to: '/support' },
    ],
  },
  {
    title: 'Help & Legal',
    links: [
      { label: 'Contact Us', href: 'mailto:support@ab8beauty.com' },
      { label: 'My Account', to: '/account' },
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
    ],
  },
];

/* A single footer link with a pink dash that grows in on hover. */
function FooterLink({ label, to, href }) {
  const inner = (
    <span className="group inline-flex items-center gap-2 text-[13.5px] text-pink-100/55 transition-colors duration-200 hover:text-white">
      <span className="h-px w-0 bg-tea-400 transition-all duration-300 group-hover:w-3.5" aria-hidden />
      {label}
    </span>
  );
  return to ? <Link to={to}>{inner}</Link> : <a href={href}>{inner}</a>;
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="relative overflow-hidden text-pink-100/70"
      style={{ background: 'linear-gradient(180deg,#2b1722 0%,#1a0c12 100%)' }}
    >
      {/* hairline accent + soft brand glows for depth */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-tea-500/70 to-transparent" />
      <div aria-hidden className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-tea-500/10 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -bottom-32 right-0 h-80 w-80 rounded-full bg-plum-600/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        {/* ── Brand + link columns ── */}
        <div className="grid gap-12 py-16 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src="/logo-ab8.svg" alt="AB8 Beauty & Skin" className="h-12 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-pink-100/55">
              Clean, glow-forward beauty &amp; skincare — formulated to feel as good as it looks.
            </p>
            <div className="mt-6 flex items-center gap-2.5">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={s.name}
                  title={s.name}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-pink-100/70 ring-1 ring-white/10 transition-all duration-200 hover:-translate-y-0.5 hover:bg-tea-500 hover:text-white hover:ring-tea-400"
                >
                  <svg viewBox="0 0 24 24" className="h-[18px] w-[18px]" fill="currentColor" aria-hidden>
                    <path d={s.d} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-tea-300">
                  {col.title}
                </h4>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <FooterLink {...l} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* ── Trust band: guarantees + secure checkout / payments ── */}
        <div className="grid items-center gap-10 border-t border-white/10 py-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <GuaranteeMedallions className="max-w-lg" onDark />
          </div>
          <div className="lg:col-span-5 lg:border-l lg:border-white/10 lg:pl-10">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-pink-100/80">
              <svg
                className="h-4 w-4 text-tea-400"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="5" y="11" width="14" height="9" rx="1.5" />
                <path d="M8 11V8a4 4 0 0 1 8 0v3" />
              </svg>
              Guaranteed safe &amp; secure checkout
            </p>
            <PaymentMethods className="mt-3.5" />
          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="flex flex-col gap-4 border-t border-white/10 py-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-pink-100/45">
            © {year} AB8 Beauty &amp; Skin. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs">
            <Link to="/terms" className="text-pink-100/45 transition-colors hover:text-white">Terms</Link>
            <Link to="/privacy" className="text-pink-100/45 transition-colors hover:text-white">Privacy</Link>
            <Link to="/compliance" className="text-pink-100/45 transition-colors hover:text-white">Compliance</Link>
          </div>
        </div>

        {/* ── Regulatory disclaimer ── */}
        <p className="mx-auto max-w-4xl border-t border-white/5 pb-10 pt-6 text-center text-[11px] leading-relaxed text-pink-100/35">
          Cosmetic skincare products for external use only. Individual results may vary. These products are
          not intended to diagnose, treat, cure, or prevent any disease and have not been evaluated by the FDA.
          Referral rewards accrue as account cash redeemable at checkout, subject to the program terms.
        </p>
      </div>
    </footer>
  );
}
